import React, { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useSpots } from '../../../lib/spots';
import { getSpotPermissions } from 'lib/spot-permissions';
import { getPermissions } from 'lib/permissions';
import { UserPage } from 'components/UserPage';
import { Section } from 'components/Section';
import { BreadCrumbs } from 'components/BreadCrumbs';


type Props = {};


export const SpotAdminPage: FC<Props> = (props) => {
    // @ts-ignore
    const id = props.match.params.id;
    const { get } = useSpots();
    const [spot, setSpot] = useState<Spot | null>(null);
    const history = useHistory();

    useEffect(() => {
        async function initialize() {
            const spotPermissions = await getSpotPermissions(id);
            const userPermission = await getPermissions();
            if (!spotPermissions.view) {
                if (userPermission.status === 'unpaid') {
                    history.push(
                        `/map/spot/${id}`,
                        {
                            flash: 'サービスをご利用になるには未払い金をお支払いください。',
                            error: true,
                        },
                    );
                }
                return;
            }
            const spot = await get(id);
            setSpot(spot);
        }
        initialize();
    });

    return (
        <UserPage title="Salon.jp | お店管理画面" disableBackButton={true}>
            <Section fillOnSp={true}>
                {spot && (
                    <div className="bread-crumbs-wrapper">
                        <BreadCrumbs items={[
                            {
                                title: 'お店の一覧',
                                href: '/map/my_list',
                            },
                            {
                                title: spot.name,
                                href: `/map/spot/${id}`,
                            },
                            {
                                title: 'お店管理',
                                href: `/map/spot/${id}/admin`,
                            },
                        ]} />
                    </div>
                )}
                <div className="wrap">
                    <h1 className="title">お店管理画面</h1>
                    <ul className="menu">
                        <li className="item">
                            <img src="/img/map_admin/staff.png" alt="" />
                            <a className="text" href={`/map/spot/${id}/staff`}>スタッフ管理</a>
                            <img className="arrow" src="/img/menu/icon-menu-arrow.png" alt="" />
                        </li>
                        <li className="item">
                            <img className="icon" src="/img/edit_spot.png" />
                            <a className="text" href={`/map/spot/${id}/edit`}>お店情報の編集</a>
                            <img className="arrow" src="/img/menu/icon-menu-arrow.png" alt="" />
                        </li>
                        <li className="item">
                            <img className="icon" src="/img/map_admin/customer.png" alt="" />
                            <a className="text" href={`/map/spot/${id}/users`}>お客様一覧</a>
                            <img className="arrow" src="/img/menu/icon-menu-arrow.png" alt="" />
                        </li>
                        <li className="item">
                            <img className="icon" src="/img/map_admin/qr.png" alt="" />
                            <a className="text" href={`/map/spot/${id}/qr`}>スタンプQRコードの表示</a>
                            <img className="arrow" src="/img/menu/icon-menu-arrow.png" alt="" />
                        </li>
                        <li className="item">
                            <img className="icon" src="/img/map_preview.png" />
                            <a className="text" href={`/map/spot/${id}`}>お店のトップへ</a>
                            <img className="arrow" src="/img/menu/icon-menu-arrow.png" alt="" />
                        </li>
                    </ul>
                </div>
            </Section>

            <style jsx>{`
                .bread-crumbs-wrapper {
                    padding-top: 10px;
                    padding-bottom: 20px;
                }
                .wrap {
                    min-height: 50vh;
                    padding: 1rem;
                    padding-top: 0px;
                }
                .title {
                    font-size: 1rem;
                }
                .menu {
                    margin-left: 0;
                    padding-left: 0;
                    border-top: 1px solid #eeeeee;
                    line-style: none;
                }
                .menu > .item {
                    display: flex;
                    jsutify-content: space-between;
                    align-items: center;
                    border-bottom: 1px solid #eeeeee;
                }
                .item > .icon {
                    width: 52px;
                    height: 52px;
                }
                .item > .text {
                    display: block;
                    flex-grow: 1;
                    padding: 1.2rem 0 1.2rem 1rem;
                }
                .item > a.text:link,
                .item > a.text:visited,
                .item > a.text:hover,
                .item > a.text:active {
                    text-decoration: none;
                    color: #000000;
                }
                .item > .arrow {
                    width: 1.5rem;
                }
                @media screen and (max-width: 540px) {
                    .wrap {
                        min-height: 100vh;
                    }
                }
            `}</style>
        </UserPage>
    );
};
